import React from 'react';
import Axios from 'axios';
import moment from 'moment';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import HandicapTypeSelect from '../../shared/Tools/HandicapTypeSelect';

import { SS_VALIDATION_TRANSLATION, HANDICAPTYPE } from "../../shared/constants/constants";


class SeasonScheduledMatchModal extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			scheduledMatch: this.props.modalScheduledMatch,
			locations: [],
			teams: [],
			ssFormats: []
		};

		this.handleInputChg = this.handleInputChg.bind(this);
		this.handleValidationStatusChg = this.handleValidationStatusChg.bind(this);
		this.handleSaveScheduledMatch = this.handleSaveScheduledMatch.bind(this);
	}

	componentDidMount() {
		// console.log('SeasonScheduledMatchModal: componentDidMount');
		this.initModalState(this.props);
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		// console.log('SeasonScheduledMatchModal: UNSAFE_componentWillReceiveProps');
		this.initModalState(nextProps);
	}

	initModalState(props) {
		var _this = this;
		var seasonId = props.season._id;

		// Get seasonMatchsExtra
		Axios.get('/api/scoresheets2/seasonMatchsExtra/seasonId/' + seasonId).then(function(response) {

			// console.log('initModalState: response.data');
			// console.log(response.data);
			var locations = response.data.locations;
			var teams = response.data.teams;
			var ssFormats = response.data.ssFormats;

			_this.setState({
				scheduledMatch: props.modalScheduledMatch,
				locations: locations,
				teams: teams,
				ssFormats: ssFormats,
				disableSubmit: false
			});
		});
	}

	render() {
		console.log('SeasonScheduledMatchModal: render');
		console.log(this.props.modalScheduledMatch);
		console.log(this.props.season);
		console.log(this.state);

		var { scheduledMatch } = this.state;
		var addEditText = "Ajout";
		if (scheduledMatch._id !== "0") {
			addEditText = "Modification";
		}

		return (
    	<Modal 
  			isOpen={this.props.showModal} 
    		//toggle={this.props.handleModalCancel}		// when clicking outside the modal
				size={"sm"}
    		className={this.props.className}>

        <form className="form-horizontal" onSubmit={this.handleSaveScheduledMatch}>
    		<ModalHeader>
    			{/* toggle={this.props.handleModalCancel}> displays a small X in header */}
    			Match<br/>{addEditText}
    		</ModalHeader>

    		<ModalBody>
					{this.dispForm()}
    		</ModalBody>

    		<ModalFooter>
      		<button type="button" className="btn btn-secondary btn-sm stdCommandButton2" 
      			onClick={this.props.handleModalCancel}> Annuler
      		</button>
      		<button type="submit" className="btn btn-primary btn-sm stdCommandButton2"> 
      			Enregistrer
      		</button>
    		</ModalFooter>
    		</form>
    	</Modal>
    )
	}

	dispForm() {
		let { scheduledMatch } = this.state;
		let validationStatusOption1 = "None";
		let validationStatusOption2 = "Validated";
		let validationStatusValue = scheduledMatch.validation.validationStatusTxt;
  	SS_VALIDATION_TRANSLATION.forEach(ssvt => {
  		if (validationStatusOption1 === ssvt.en) {
  			validationStatusOption1 = ssvt.fr;
  		}
  		if (validationStatusOption2 === ssvt.en) {
  			validationStatusOption2 = ssvt.fr;
  		}
  		if (validationStatusValue === ssvt.en) {
  			validationStatusValue = ssvt.fr;
  		}
   	});

		return (
			<div>
        <div className="row row-margin-bottom-10">
        <div className="col-12">
					<span className="small"> Date </span> <br/>
          <input className="form-control form-control-sm" type="date" id="dateScheduled" 
          	value={scheduledMatch.dateScheduled || ''}
            onChange={this.handleInputChg}></input>
				</div>
				</div>

        <div className="row row-margin-bottom-10">
        <div className="col-12">
					<span>Sous-saison</span>
		  		<select className="form-control form-control-sm input-sm" type="text" id="subSeasonId" 
		  			value={scheduledMatch.subSeasonId} onChange={this.handleInputChg}>
		  				{this.props.season.subSeasons.map(this.optSubSeasons)}
					</select>
				</div>
				</div>

        <div className="row row-margin-bottom-10">
        <div className="col-6">
					<span className="small"> Programme </span> <br/>
          <input className="form-control form-control-sm" type="number" id="week" min={1} max={9999} 
          	value={scheduledMatch.week || -1}
            onChange={this.handleInputChg}></input>
				</div>
        <div className="col-6">
					<span className="small"> Match # </span> <br/>
          <input className="form-control form-control-sm" type="text" id="ssIdx" disabled
          	value={scheduledMatch.ssIdx || ''}
            onChange={this.handleInputChg}></input>
				</div>
				</div>

        <div className="row row-margin-bottom-10">
        <div className="col-12">
					<span className="small"> Format de feuille </span> <br/>
		  		<select className="form-control form-control-sm input-sm" type="text" id="scoresheetFormatId" 
		  			value={scheduledMatch.scoresheetFormatId} onChange={this.handleInputChg}>
		  				<option value="0">Choisir une feuille</option>
		  				{this.state.ssFormats.map(this.optSsFormats)}
					</select>
				</div>
				</div>

        <div className="row row-margin-bottom-10">
          <div className="col-6">
            <span className="small"> Type Handicap </span> <br/>
						<HandicapTypeSelect 
							id="handicapType"	specificClass="form-control-sm input-sm"
							handicapType={scheduledMatch.handicapType} 
							handicapTypeChange={this.handicapTypeChange}/>

          </div>
          <div className="col-6">
            <span className="small"> Max Handicap </span> <br/>
            <input
              className="form-control form-control-sm"
              type="number" id="handicapMax" min={0} placeholder="Aucun"
              value={
                scheduledMatch.handicapMax !== null &&
                scheduledMatch.handicapMax !== undefined
                  ? scheduledMatch.handicapMax
                  : ''
              }
              onChange={this.handleInputChg}
						  onWheel={e => e.target.blur()} // ⚡ bloque le scroll qui modifie la valeur
            />
          </div>
        </div>

        <div className="row row-margin-bottom-10">
        <div className="col-12">
					<span className="small"> Lieu </span> <br/>
		  		<select className="form-control form-control-sm input-sm" type="text" id="locationId" 
		  			value={scheduledMatch.locationId} onChange={this.handleInputChg}>
		  				<option value="0">Choisir un lieu</option>
		  				{this.state.locations.map(this.optLocations)}
					</select>
				</div>
				</div>

        <div className="row row-margin-bottom-10">
        <div className="col-12">
					<span className="small"> Équipe A </span> <br/>
 		  		<select className="form-control form-control-sm input-sm" type="text" id="team1Id" 
		  			value={scheduledMatch.team1Id} onChange={this.handleInputChg}>
		  				<option value="0">Choisir une équipe</option>
		  				{this.state.teams.map(this.optTeams)}
					</select>
				</div>
				</div>

        <div className="row row-margin-bottom-10">
        <div className="col-12">
					<span className="small"> Équipe B </span> <br/>
 		  		<select className="form-control form-control-sm input-sm" type="text" id="team2Id" 
		  			value={scheduledMatch.team2Id} onChange={this.handleInputChg}>
		  				<option value="0">Choisir une équipe</option>
		  				{this.state.teams.map(this.optTeams)}
					</select>
				</div>
				</div>

        <div className="row row-margin-bottom-10">
        <div className="col-12">
					<span className="small"> Validation </span> <br/>
 		  		<select className="form-control form-control-sm input-sm" type="text" id="validationStatus" 
		  			value={validationStatusValue} onChange={this.handleValidationStatusChg}>
		  				<option>{validationStatusOption1}</option>
		  				<option>{validationStatusOption2}</option>
					</select>
				</div>
				</div>

			</div>
		)
	}

	optSubSeasons(ss, ssIdx, subSeasons) {
		return ( <option value={ss.id} key={'ss.' + ssIdx}> {ss.name} </option>	)
	}
	optSsFormats(ssf, ssfIdx, ssFormats) {
		return ( <option value={ssf._id} key={'ssf.' + ssfIdx}> {ssf.tag} </option>	)
	}
	optLocations(loc, locIdx, locations) {
		return ( <option value={loc._id} key={'loc.' + locIdx}> {loc.name} </option> )
	}
	optTeams(team, teamIdx, teams) {
		return ( <option value={team._id} key={'team.' + teamIdx}> {team.name} </option> )
	}

	handleInputChg(e) {
		console.log("handleInputChg")
		console.log(e)
		console.log(e.target)

	  let { scheduledMatch } = this.state;
	  const { id, value } = e.target;

	  if (id === "handicapMax") {
	    scheduledMatch.handicapMax =
	      value === "" ? null : Number(value);
	  } else {
	    scheduledMatch[id] = value;
	  }
	  
	  this.setState({ scheduledMatch });
	}

	handicapTypeChange = (handicapType) => {
	  this.setState(prev => ({
	    scheduledMatch: {
	      ...prev.scheduledMatch,
	      handicapType
	    }
	  }));
	}

	handleValidationStatusChg(e) {
		let { scheduledMatch } = this.state;
		var newValue = e.target.value;

		// validationStatus option translation
  	SS_VALIDATION_TRANSLATION.forEach(ssvt => {
  		if (newValue === ssvt.fr) {
  			newValue = ssvt.en;
  		}
   	});			

		scheduledMatch.validation.validationStatusTxt = newValue;
		this.setState({	scheduledMatch: scheduledMatch });
	}

	handleSaveScheduledMatch(e) {
		// console.log('handleSaveScheduledMatch !');
		e.preventDefault();

		if (this.state.disableSubmit) {
			return;
		}

		var _this = this;
		var scheduledMatch = this.state.scheduledMatch;

		// Validation
		if ((scheduledMatch.dateScheduled === null) || 
				(scheduledMatch.scoresheetFormatId === '0') || 
				(scheduledMatch.locationId === '0') || 
			  (scheduledMatch.team1Id === '0') || (scheduledMatch.team2Id === '0')) {
			alert('Vous devez spéficier tous les champs');
		
		}	else if (scheduledMatch.team1Id === scheduledMatch.team2Id) {
			alert('Les équipes doivent être différentes');

		} else {
			_this.setState({
				disableSubmit: true
			});

			//console.log('Modal Save')
			//console.log(scheduledMatch)

			// Post operation
			Axios.post('/api/scoresheets2/saveScoresheet', {
				scoresheet: scheduledMatch,
			})
			.then(function(response) {
				_this.props.reloadData();
				
				_this.props.handleModalCancel();
			})
			.catch(function(error) {
				console.log('ERROR');
				console.log(error);
				_this.props.handleModalCancel();
			});
		}
	}

	isNumeric(n) {
		// not good for negative values
		return !isNaN(parseFloat(n)) && isFinite(n);
	}

}

export default SeasonScheduledMatchModal;